import React, { useState } from "react";
import {
  format,
  setMonth,
  setYear,
  subMonths,
  addMonths,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  isSameMonth,
  isSameDay,
} from "date-fns";

const CalendarHomeTest = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());

  const monthNames = [
    "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
    "JUL", "AUG", "SEP", "OCT", "NOV", "DEC",
  ];

  const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - 5 + i);

  const handleMonthClick = (monthIndex) => {
    setCurrentDate(setMonth(currentDate, monthIndex));
  };

  const handleYearChange = (e) => {
    setCurrentDate(setYear(currentDate, parseInt(e.target.value)));
  };

  const goToPrevMonth = () => {
    setCurrentDate(subMonths(currentDate, 1));
  };

  const goToNextMonth = () => {
    setCurrentDate(addMonths(currentDate, 1));
  };

  const generateCalendarDays = () => {
    const startMonth = startOfMonth(currentDate);
    const endMonth = endOfMonth(currentDate);
    const startDate = startOfWeek(startMonth, { weekStartsOn: 1 });
    const endDate = endOfWeek(endMonth, { weekStartsOn: 1 });

    const days = [];
    let day = startDate;
    while (day <= endDate) {
      days.push(day);
      day = addDays(day, 1);
    }

    return days.map((date, index) => (
      <div
        key={index}
        className={` text-sm rounded-2xl w-6 mx-4 my-0.75 cursor-pointer ${
          !isSameMonth(date, currentDate) ? "text-gray-300" : ""
        } ${
          isSameDay(date, selectedDate)
            ? "bg-red-500 text-white "
            : "hover:bg-red-100"
        }`}
        onClick={() => setSelectedDate(date)}
      >
        {format(date, "d")}
      </div>
    ));
  };

  return (
    <div className="bg-white rounded-xl p-2  w-full h-[335px]">
      {/* Header */}
      <div className="flex justify-between items-center  my-2 ">
        <button
          onClick={goToPrevMonth}
          className="text-gray-500 hover:text-blue-500 px-2"
        >
          ◀
        </button>
        <div className="flex items-center gap-2">
          {/* Year Dropdown */}
          <select
            className="text-sm  rounded px-2 py-1"
            value={format(currentDate, "yyyy")}
            onChange={handleYearChange}
          >
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
        <button
          onClick={goToNextMonth}
          className="text-gray-500 hover:text-blue-500 px-2"
        >
          ▶
        </button>
      </div>

      {/* Month Selector */}
      <div className="grid grid-cols-12 text-xs text-center gap-1 my-2">
        {monthNames.map((m, idx) => (
          <span
            key={idx}
            onClick={() => handleMonthClick(idx)}
            className={`cursor-pointer p-1 rounded ${
              idx === currentDate.getMonth()
                ? "text-red-500"
                : "hover:text-blue-500"
                // ? "bg-red-500 text-white"
                // : "hover:bg-blue-100"
            }`}
          >
            {m}
          </span>
        ))}
      </div>

      {/* Week Days */}
      <div className="grid grid-cols-7 text-center text-xs text-gray-500 my-4 font-medium">
        {["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"].map((d) => (
          <div key={d}>{d}</div>
        ))}
      </div>

      {/* Days Grid */}
      <div className="grid grid-cols-7 gap-y-2 text-center">
        {generateCalendarDays()}
      </div>
    </div>
  );
};

export default CalendarHomeTest;
